import { Injectable } from '@angular/core';
import { ApiUrlHelper, UrlQueryParams } from '../api-url-helper';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { StorageService } from '../../storageprovider';
import { map } from 'rxjs/operators';
import { Utility } from '../utility';
import { GGList } from './default.gg';

@Injectable()
export class GgService {
    isAdult = environment.cinema === 2;

    ggs;
    // ls1;
    // ls2;

    private _ggService = new BehaviorSubject<any>([]);
    ggSource$ = this._ggService.asObservable();

    // private _ls1Service = new BehaviorSubject<any>([]);
    // ls1Source$ = this._ls1Service.asObservable();

    // private _ls2Service = new BehaviorSubject<any>([]);
    // ls2Source$ = this._ls2Service.asObservable();

    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _httpClient: HttpClient,
        private _storage: StorageService,
        private _utility: Utility
    ) { }

    // updateLS(id, region) {

    //     var key = this.isAdult ? 'ALS' + id.toString() : 'LS' + id.toString();
    //     var item = this._storage.GetItem(key);
    //     var LSStorage = item != null ? JSON.parse(item) : null;

    //     if (LSStorage) {
    //         const LS = LSStorage.find(gg => gg.reqRegion === region);
    //         if (LS) {
    //             if (id === 1) {
    //                 this.ls1 = LS;
    //                 this._ls1Service.next(this.ls1);
    //             } else if (id === 2) {
    //                 this.ls2 = LS;
    //                 this._ls2Service.next(this.ls2);
    //             }
    //             if (Date.now() - LS.reqDate < 60000) {
    //                 return;
    //             }
    //         }
    //     }

    //     //console.log("aaa");

    //     this.getLS(id, region).subscribe(r => {
    //         if (id === 1) {
    //             this.ls1 = r;
    //             this._ls1Service.next(this.ls1);
    //         } else if (id === 2) {
    //             this.ls2 = r;
    //             this._ls2Service.next(this.ls2);
    //         }
    //     });
    // }

    // getLS(id, region): any {
    //     return of([]);
    //     // const apiURL = this
    //     //     ._apiUrlHelper
    //     //     .urlBuilder('get-gg-block-content-LS' + id.toString(), {
    //     //         codes: this.isAdult ? 'ALS' : 'LS',
    //     //         region,
    //     //         a:1,
    //     //         flag: id === 1 ? 0 : 1
    //     //     });

    //     // return this
    //     //     ._httpClient
    //     //     .get(apiURL)
    //     //     .pipe(map(l => {
    //     //         this.saveLSToLocalStorage(id, region, l);
    //     //         return l;
    //     //     }));
    // }

    updateggs(region) {
        let ggStorage = null;
        try {
            ggStorage = JSON.parse(this._storage.GetItem('ggs'));
        }
        catch
        {

        }
        if (ggStorage) {
            const ggs = ggStorage.find(gg => gg.reqRegion === region);
            if (ggs) {
                this.ggs = ggs;
                this._ggService.next(this.ggs.data);
                if (Date.now() - ggs.reqDate < 60000) {
                    return;
                }
            }
        }

        this.getGgs(region).subscribe(r => {
            this.ggs = r;
            this._ggService.next(this.ggs.data);
        });
    }

    getGgs(region): Observable<any> {

        if (this._utility.getSiteConfig.hideAds) {
            return of(GGList);
        }
        else {
            const apiURL = this._apiUrlHelper.urlBuilder('get-gg-block-content', {});

            let fa = ['PB', 'PRU', 'PRD', 'SS', 'DL', 'H4'];
            if (this.isAdult) {
                fa = ['VPB', 'VPRU', 'VPRD', 'VSS', 'VDL', 'H4'];
            }

            const httpOptions = {
                headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
                withCredentials:true ////cdn防御
            };

            const body = new UrlQueryParams();

            if (region) {
                body.set('region', region);
            }
            body.set("a", 1);
            body.set("skin", !!parseInt(this._storage.GetConfig()["isDark"]) ? 1 : 0); // 0浅色，1深色
            fa.forEach(c => {
                body.append('codes', c);
            });
            return this._httpClient.post(apiURL, body.toString(), httpOptions)
                .pipe(map(l => {
                    // console.log(l)
                    var result: any = {
                        country: l["country"],
                        reqDate: l["reqDate"],
                        reqRegion: l["reqRegion"],
                        systime: l["systime"],
                        data: []
                    };
                    for (var i = 0; i < l["data"].length; ++i) {
                        result.data.push({
                            position: l["data"][i]["Position"],
                            rawImage: l["data"][i]["RawImage"],
                            linkUrl: l["data"][i]["LinkURL"],
                            isLonger: !!l["data"][i]["IsLargeImg"] ? l["data"][i]["IsLargeImg"] : false,
                        });
                    }
                    this.saveGgsToLocalStorage(region, result);
                    return result;
                }));
        }

    }

    record(region) {
        //console.log("record")
        const apiURL = this._apiUrlHelper.urlBuilder('get-gg-block-content', {});
        const body = new UrlQueryParams();
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
        if (region) {
            body.set('region', region);
        }
        try {
            body.set("skin", parseInt(this._storage.GetConfig()["isDark"] || "1")); // 0浅色，1深色
        }
        catch (err) { }

        //  console.log(apiURL);
        return this._httpClient.post(apiURL, body.toString(), httpOptions)
            .pipe(map(l => {
                // console.log(l);
                // this.saveGgsToLocalStorage(region, l);
                return l;
            }));
    }
    private adsKey = "ggs_20xx"

    saveGgsToLocalStorage(region, ggs) {
        ggs.reqRegion = region;
        ggs.reqDate = Date.now();

        let ggStorage = JSON.parse(this._storage.GetItem(this.adsKey));
        if (!ggStorage) {
            ggStorage = [];
        }
        ggStorage = ggStorage.filter(gg => gg.reqRegion !== region);

        ggStorage.push(ggs);

        this._storage.SetItem(this.adsKey, JSON.stringify(ggStorage));
    }

    getGgsFromLocalStorage(region) {
        const ggStorage = JSON.parse(this._storage.GetItem(this.adsKey));
        return ggStorage.find(gg => gg.reqRegion === region);
    }

    // saveLSToLocalStorage(id, region, LS) {
    //     LS.reqRegion = region;
    //     LS.reqDate = Date.now();
    //     let LSStorage = this.isAdult
    //         ? JSON.parse(this._storage.GetItem('ALS' + id.toString()))
    //         : JSON.parse(this._storage.GetItem('LS' + id.toString()));
    //     if (!LSStorage) {
    //         LSStorage = [];
    //     }
    //     LSStorage = LSStorage.filter(ls => ls.reqRegion !== region);

    //     LSStorage.push(LS);
    //     if (this.isAdult) {
    //         this._storage.SetItem('ALS' + id.toString(), JSON.stringify(LSStorage));
    //     } else {
    //         this._storage.SetItem('LS' + id.toString(), JSON.stringify(LSStorage));
    //     }
    // }

    // getLSFromLocalStorage(id, region) {
    //     const LSStorage = this.isAdult
    //         ? JSON.parse(this._storage.GetItem('ALS' + id.toString()))
    //         : JSON.parse(this._storage.GetItem('LS' + id.toString()));
    //     return LSStorage.find(LS => LS.reqRegion === region);
    // }
}
